import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SkyBackdrop } from "@/components/SignInScreen";

export const AuthCallback = () => {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await http.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data ?? null);
      } catch {
        setUser(null);
      }
      nav("/", { replace: true });
    })();
  }, [nav, setUser]);

  return (
    <div className="fixed inset-0 grid place-items-center overflow-hidden" data-testid="auth-callback-screen">
      <SkyBackdrop />
      <p className="relative font-display italic text-3xl text-purple-50">Opening the hollow…</p>
    </div>
  );
};
